import ApiService from '@services/api.service';
import { Notify } from 'quasar';
export const etudiantSuivis = {
  state: {
    etudiantSuivi: null,
    etudiantSuivis: [],
  },
  mutations: {
    setEtudiantSuivi(state, etudiantSuivi){
      state.etudiantSuivi = etudiantSuivi;
    },
    setEtudiantSuivis(state, etudiantSuivis){
      state.etudiantSuivis = etudiantSuivis
    }
  },
  actions: {
    async editEtatSuivi(context, data){
      try{
        const response = await ApiService.postRequest(data.url, {etat: data.etat});
        context.commit('setEtudiantSuivi', response.data);
      }catch(error){
        console.error(error);
        Notify.create({
          message:"Une erreur s'est produite",
          color: "red"
        })
      }
    }
  },
  getters: {
    getEtudiantSuivi(state){
      return state.etudiantSuivi;
    },
    getEtudiantSuivis(state){
      return state.etudiantSuivis;
    }
  }
}
